import {load, addLink, createTd, insertRow} from './common';

declare const data: [string, number][] & {timestamp?: string};

const ERROR_DESCRIPTIONS: Record<string, string> = {
	'hans-has-hant': '简体变体规则中出现繁体字',
	'hant-has-hans': '繁体变体规则中出现简体字',
};

const lang = new URLSearchParams(location.search).get('lang') ?? 'zh';
const h2 = document.querySelector('h2')!;

load(`./data/${lang}/index.js`, () => {
	if (data.timestamp) {
		h2.textContent += ` (${data.timestamp})`;
	}
	for (const [errorType, count] of data) {
		insertRow(
			addLink('td', errorType, `./type.html?lang=${lang}&type=${errorType}`),
			createTd(ERROR_DESCRIPTIONS[errorType] ?? errorType),
			createTd(String(count)),
		);
	}
});
